import { FC } from "react";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import "dayjs/locale/es";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as DatePickerMUI } from "@mui/x-date-pickers/DatePicker";

type Props = {
  value?: any;
  name: string;
  label: string;
  error?: boolean;
  disabled?: boolean;
  helperText?: string;
  onChange: (value: any) => void;
};

const DatePicker: FC<Props> = ({ name, value, error, label, onChange, helperText, disabled }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} locale='es'>
      <Stack spacing={2}>
        <DatePickerMUI
          label={label}
          value={value}
          disabled={disabled}
          onChange={onChange}
          renderInput={(params) => (
            <TextField margin='normal' value={value} name={name} helperText={helperText} {...params} error={error} />
          )}
        />
      </Stack>
    </LocalizationProvider>
  );
};

export default DatePicker;
